/**
 * Size guide CM / IN unit switcher
 */
(function () {
  class SizeGuideUnits extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-size-guide-unit]'));
      this.panels = Array.from(this.querySelectorAll('[data-size-guide-panel]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectUnit(button.getAttribute('data-size-guide-unit')));
      });
    }

    selectUnit(unit) {
      if (!unit) return;

      this.buttons.forEach((button) => {
        const isActive = button.getAttribute('data-size-guide-unit') === unit;
        button.setAttribute('aria-selected', String(isActive));
      });

      this.panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-size-guide-panel') === unit;
        panel.hidden = !isActive;
      });
    }
  }

  if (!customElements.get('size-guide-units')) {
    customElements.define('size-guide-units', SizeGuideUnits);
  }
})();
